import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('widgets-management-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('cms-widgetsManagement', {
        parent: 'arw',
        url: '/cms-widgets-management/',
        params: {
          skipReloadData: false,
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Home Page Widgets')));
            },
          ],
        },
        template: '<widgets-management></widgets-management>',
        redirectTo: 'permissions-denied',
      })
      .state('cms-editWidget', {
        parent: 'arw',
        url: '/cms-edit-widget/{id:[0-9]*}',
        template: '<widgets-edit></widgets-edit>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Home Page Widgets')));
            },
          ],
          skipDirtyForms: false,
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/widgets/widgets-management-routing-module.js